import { Grid, SelectChangeEvent, Typography } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import UseRadioGroup from '../../lib/formik/Radio';
import { MFTextField } from '../../lib/formik';
import { ApplicationProps, JointholderRelationMaster } from '../../redux-store/types/api-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { useHistory } from 'react-router';
import { getFunds } from '../../redux-store/actions/funds';
import { ClassPlanProps, FundProps } from '../../redux-store/types/funds';
import { investmentPaymentDetailsSchema } from '../../utils/schema';
import MFCheckbox from '../../lib/formik/Checkbox';
import {
  APPLICATION_TYPE,
  DISTRIBUTION_FEE_TYPE_MASTER,
  DistributorFeeValidationStartDate,
  INVESTMENT_METHOD_MASTER,
  MODE_OF_PAYMENT_MASTER,
  RiskProfileEnabled,
  // eslint-disable-next-line
  SIP_MASTER,
  USER_ROLES,
  defaultCurrency,
  ENABLE_FAMILY_FOLIO,
} from '../../utils/constant';
import {
  allowOnlyNumbers,
  applicationComparison,
  checkValidationBasedOnDate,
  currencyConversion,
  isAccreditedInvestorApplicable,
  isChequeOrRTGS,
  isFieldApplicable,
  isFieldVariable,
  isNEFT,
  isSchemeNICO,
  isSchemeNIDI2A,
  saveForLater,
  setUpFeeCalculations,
  statusRoleBased,
  updatedCommitmentAmount,
} from '../../utils/utilityFunctions';
import { useSnackbar } from 'notistack';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { jointHolderRelationsList } from '../../redux-store/actions';
import { DatePicker } from '../../lib/formik/DatePicker';
import MFSelectField from '../../lib/formik/SelectField';
import { checkDrawdown, checkLumpsum, checkSip } from '../FundsSetup/addFund';
import { error } from 'console';
import { is } from 'date-fns/locale';
import { ConfirmationDialog } from '../commonComponents';

type Values = Partial<ApplicationProps> & {
  saveType: string;
};

const fundInitialValues = {
  schemeId: '',
  planId: '',
  commitmentAmount: 0,
  setupFeePercentage: 0,
  managementFeesRate: 0,
  taxRate: 0,
  drawDownNumber: 0,
  contributionChequeAmount: 0,
  setupFeeAmount: null,
  setupFeeGST: null,
  totalSetupFee: null,
  setupFeeTDS: null,
  netSetupFeeLessTDS: null,
  totalAmountPayable: null,
  sip: '',
  modeOfInvestment: '',
  investmentPercentage: '',
  investmentMonths: '',
  distributorFeeType: 'full_trail',
  upfrontPlusTrail: 0,
  hurdleRateApplicable: '',
  hurdleRateType: '',
  hurdleRate: null,
  performanceFeeApplicable: '',
  performanceFeeType: '',
  performanceFee: null,
  addReturnSplitApplicable: '',
  addReturnSplitType: '',
  addReturnSplit: null,
  isAccreditedInvestor: false,
  groupInvestment: null,
  groupName: '',
  schemeShortName: '',
  isOnlyXalt: false,
};

const initialValues: Values = {
  ...fundInitialValues,
  modeOfPayment: 'cheque',
  paymentRefNo: '',
  neftCode: '',
  paymentRefDate: null,
  placementFee: null,
  distributorFee: 0,
  chequeDate: '',
  paymentBankAccountNumber: '',
  paymentBankame: '',
  paymentBankAccontType: '',
  drawnOnBank: '',
  drawnAccountNumber: '',
  drawnBankBranch: '',
  drawnCity: '',
  isAccreditedInvestor: false,
  saveType: 'save and proceed',
  schemeShortName: '',
};

export default function InvestmentPaymentDetails(): JSX.Element {
  // const [open, setOpen] = useState(false);
  // eslint-disable-next-line
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [fundsList, setFundsList] = useState<FundProps[]>([]);
  const [selectedFund, setSelectedFund] = useState<FundProps | null>(null);
  const [loading, setLoading] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState<Partial<ClassPlanProps> | null>(null);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [paymentDetails, setPaymentDetails] = useState(initialValues);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [jointHoldersData, setJointHoldersData] = useState<JointholderRelationMaster>();
  const [openDialog, setDialog] = useState<{
    investmentData: Values;
    checkApplication: boolean;
  } | null>(null);

  const {
    minCommitmentAmount = 10000000,
    maxCommitmentAmount = 20000000,
    // eslint-disable-next-line
    minContributionPercentage = 10,
    // eslint-disable-next-line
    currency = defaultCurrency,
    minHurdleRate = 0,
    minPerformanceFee = 0,
    maxHurdleRate = 100,
    maxPerformanceFee = 100,
    minAddReturnSplit = 0,
    maxAddReturnSplit = 100,
  } = selectedPlan || {};

  useEffect(() => {
    const { plan } = application || ({} as ApplicationProps);
    const {
      minCommitmentAmount = 1,
      maxCommitmentAmount = 0,
      minContributionPercentage = 1,
      currency = defaultCurrency,
      minHurdleRate = 0,
      minPerformanceFee = 0,
      maxHurdleRate = 100,
      maxPerformanceFee = 100,
      transactionCurrency = defaultCurrency,
      minAddReturnSplit = 0,
      maxAddReturnSplit = 100,
      accreditedMinCommitmentAmount = 0,
      minInvestmentAmt = 0,
    } = plan || {};
    setSelectedPlan(
      plan
        ? {
            ...selectedPlan,
            minCommitmentAmount: Number(minCommitmentAmount),
            accreditedMinCommitmentAmount: Number(accreditedMinCommitmentAmount),
            maxCommitmentAmount: Number(maxCommitmentAmount),
            minContributionPercentage: Number(minContributionPercentage),
            currency,
            minHurdleRate: Number(minHurdleRate),
            minPerformanceFee: Number(minPerformanceFee),
            maxHurdleRate: maxHurdleRate === 0 || maxHurdleRate ? Number(maxHurdleRate) : 100,
            maxPerformanceFee:
              maxPerformanceFee === 0 || maxPerformanceFee ? Number(maxPerformanceFee) : 100,
            transactionCurrency: transactionCurrency || defaultCurrency,
            minAddReturnSplit: Number(minAddReturnSplit),
            maxAddReturnSplit:
              maxAddReturnSplit === 0 || maxAddReturnSplit ? Number(maxAddReturnSplit) : 100,
            minInvestmentAmt: Number(minInvestmentAmt),
          }
        : null
    );

    setPaymentDetails({
      ...paymentDetails,
      schemeId: application?.schemeId || '',
      planId: application?.planId || '',
      isAccreditedInvestor: application?.isAccreditedInvestor || false,
      commitmentAmount: application?.commitmentAmount || null,
      setupFeePercentage: application?.setupFeePercentage || 0,
      managementFeesRate: application?.managementFeesRate || 0,
      // taxRate: application?.taxRate || null,
      // drawDownNumber: application?.drawDownNumber || null,
      contributionChequeAmount: Number(application?.contributionChequeAmount) || 0,
      modeOfPayment: application?.modeOfPayment || '',
      paymentRefNo: application?.paymentRefNo || '',
      neftCode: application?.neftCode || '',
      paymentRefDate: application?.paymentRefDate || null,
      placementFee:
        application?.placementFee || application?.placementFee === 0
          ? application?.placementFee
          : null,
      distributorFee:
        application?.distributorFee || application?.distributorFee === 0
          ? application?.distributorFee
          : null,
      chequeDate: application?.chequeDate || null,
      paymentBankAccountNumber: application?.paymentBankAccountNumber || '',
      paymentBankame: application?.paymentBankame || '',
      paymentBankAccontType: application?.paymentBankAccontType || '',
      setupFeeAmount: application?.setupFeeAmount,
      setupFeeGST: application?.setupFeeGST,
      totalSetupFee: application?.totalSetupFee,
      setupFeeTDS: application?.setupFeeTDS,
      netSetupFeeLessTDS: application?.netSetupFeeLessTDS,
      totalAmountPayable: application?.totalAmountPayable,
      sip: application?.sip || '',
      drawnOnBank: application?.drawnOnBank || '',
      drawnAccountNumber: application?.drawnAccountNumber || '',
      drawnBankBranch: application?.drawnBankBranch || '',
      drawnCity: application?.drawnCity || '',
      modeOfInvestment: application?.modeOfInvestment || '',
      distributorFeeType: application?.distributorFeeType || 'full_trail',
      upfrontPlusTrail: application?.upfrontPlusTrail || 0,
      investmentPercentage: application?.investmentPercentage || '',
      investmentMonths: application?.investmentMonths || '',
      hurdleRateApplicable: application?.hurdleRateApplicable || '',
      hurdleRateType: application?.hurdleRateType || '',
      hurdleRate: application?.hurdleRate || 0,
      performanceFeeApplicable: application?.performanceFeeApplicable || '',
      performanceFeeType: application?.performanceFeeType || '',
      performanceFee: application?.performanceFee || 0,
      transactionCurrency: application?.transactionCurrency || '',
      addReturnSplitApplicable: application?.addReturnSplitApplicable || '',
      addReturnSplitType: application?.addReturnSplitType || '',
      addReturnSplit: application?.addReturnSplit || 0,
      groupInvestment: ENABLE_FAMILY_FOLIO
        ? application?.applicants?.[0]?.isFamilyFolio || false
        : false,
      groupName: application?.groupName || '',
      schemeShortName: application?.scheme?.schemeShortName || '',
      isOnlyXalt: application?.isOnlyXalt || false,
    });
  }, [application]);

  function getUpdatedApplication(values: Values) {
    // eslint-disable-next-line
    const { saveType, ...rest } = values;
    const updatedApplication = {
      ...application,
      ...rest,
      paymentRefNo: isChequeOrRTGS(rest.modeOfPayment || '') ? rest.paymentRefNo : '',
      neftCode: isNEFT(rest.modeOfPayment || '') ? rest.neftCode : '',
      contributionChequeAmount: Number(rest.contributionChequeAmount) || 0,
      setupFeePercentage: Number(rest.setupFeePercentage),
      hurdleRate: isFieldApplicable(rest?.hurdleRateApplicable || '')
        ? Number(rest.hurdleRate)
        : null,
      performanceFee: isFieldApplicable(rest?.performanceFeeApplicable || '')
        ? Number(rest.performanceFee)
        : null,
      addReturnSplit: isFieldApplicable(rest?.addReturnSplitApplicable || '')
        ? Number(rest.addReturnSplit)
        : null,
      distributorFee: rest?.distributorFee || null,
      distributorFeeType:
        isSchemeNICO(selectedFund?.schemeCode || '') ||
        isSchemeNIDI2A(selectedFund?.schemeCode || '')
          ? rest.distributorFeeType
          : '',
      upfrontPlusTrail:
        isSchemeNICO(selectedFund?.schemeCode || '') ||
        isSchemeNIDI2A(selectedFund?.schemeCode || '')
          ? rest.upfrontPlusTrail
          : null,
      groupName: ENABLE_FAMILY_FOLIO && rest.groupInvestment ? rest.groupName : null,
      isOnlyXalt: rest.isOnlyXalt || false,
      schemeShortName: selectedFund?.schemeShortName || '',
    };
    return updatedApplication;
  }

  const submitInvestmentData = async (values: Values, checkApplication: boolean) => {
    const {
      id,
      applicant1ReferenceId = '',
      applicationType,
      applicationNumber,
      hasPOA,
      status,
    } = application || {};
    const { saveType } = values;
    const updatedApplication = getUpdatedApplication(values);
    const isSaveLater = saveType !== 'save and proceed';
    if (id && !checkApplication) {
      setLoading(true);
      await dispatch(
        updateApplication({
          body: {
            ...updatedApplication,

            status: statusRoleBased(role, application),
            currentStep: applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ? 4 : 8,

            // applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
            //   ? !!currentStep && currentStep > 3
            //     ? currentStep
            //     : Number(currentStep) + 1
            //   : !!currentStep && currentStep > 7
            //   ? currentStep
            //   : Number(currentStep) + 1,
          },
          applicationId: id,
          ...(isSaveLater && { toastMessage: '' }),
        })
      );
      !isSaveLater
        ? applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
          ? history.push(RiskProfileEnabled ? 'risk-profiles' : 'bank-details', {
              id,
              applicant1ReferenceId,
            })
          : history.push(RiskProfileEnabled ? 'risk-profiles' : 'document-details', {
              id,
              applicant1ReferenceId,
            })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
    } else if (checkApplication) {
      if (isSaveLater) {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
      !isSaveLater
        ? applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
          ? history.push(RiskProfileEnabled ? 'risk-profiles' : 'bank-details', {
              id,
              applicant1ReferenceId,
            })
          : history.push(RiskProfileEnabled ? 'risk-profiles' : 'document-details', {
              id,
              applicant1ReferenceId,
            })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
    }
  };

  const handleSubmit = async (values: Values) => {
    try {
      const {
        id,
        applicant1ReferenceId = '',
        currentStep,
        applicationType,
        applicationNumber,
      } = application || {};
      const { saveType } = values;
      const updatedApplication = getUpdatedApplication(values);
      const checkApplication = applicationComparison(
        { ...application, setupFeePercentage: Number(application?.setupFeePercentage) },
        {
          ...updatedApplication,
          currentStep:
            applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
              ? !!currentStep && currentStep > 3
                ? currentStep
                : Number(currentStep) + 1
              : !!currentStep && currentStep > 7
              ? currentStep
              : Number(currentStep) + 1,
        }
      );
      if (values?.groupInvestment && !checkApplication) {
        setDialog({ investmentData: values, checkApplication });
      } else {
        setLoading(true);
        await submitInvestmentData(values, checkApplication);
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        const response = (await dispatch(
          getFunds({
            isActive: true,
            ...(application?.distributorName || application?.distributor_id
              ? { isApplicableForDistributor: true }
              : { isApplicableForDirect: true }),
          })
        )) as unknown as FundProps[];
        if (!isComponentAlive) {
          return;
        }
        const { scheme } = application || {};
        const updatedFundPlan = (
          application?.schemeId && !application.scheme.isActive
            ? [
                ...response,
                {
                  ...application.scheme,
                  plans: [application.plan],
                } as unknown as FundProps,
              ]
            : response
        )?.map((item) => {
          if (item?.id?.toString() === application?.schemeId?.toString()) {
            return {
              ...item,
              modeOfInvestment: item.modeOfInvestment?.includes(application.modeOfInvestment || '')
                ? item.modeOfInvestment
                : (item.modeOfInvestment || [])
                    .concat(application.modeOfInvestment || '')
                    .filter((_item) => _item),
              drawdownDetails: checkDrawdown([application?.modeOfInvestment || ''])
                ? {
                    ...item?.drawdownDetails,
                    percentage: checkDrawdown([application?.modeOfInvestment || ''])
                      ? (item.drawdownDetails?.percentage || '')
                          ?.split(',')
                          ?.includes(application.investmentPercentage || '')
                        ? item.drawdownDetails?.percentage || ''
                        : (item.drawdownDetails?.percentage || '')
                            ?.split(',')
                            .concat(application.investmentPercentage?.toString() || '')
                            .filter((item) => item)
                            .toString()
                      : item.drawdownDetails?.percentage || '',
                  }
                : item?.drawdownDetails,
              sipDetails: checkSip([application?.modeOfInvestment || ''])
                ? item?.sipDetails?.some(
                    (_item) => _item.percentage === application.investmentPercentage
                  )
                  ? item?.sipDetails?.map((_item) =>
                      _item.percentage === application?.investmentPercentage
                        ? {
                            ..._item,
                            months: (_item?.months || '')
                              ?.split(',')
                              .includes(application?.investmentMonths || '')
                              ? _item?.months || ''
                              : (_item?.months || '')
                                  ?.split(',')
                                  .concat(application?.investmentMonths?.toString() || '')
                                  .filter((ele) => ele)
                                  ?.toString(),
                          }
                        : _item
                    )
                  : (item?.sipDetails || [])?.concat({
                      percentage: application?.investmentPercentage || '',
                      months: application?.investmentMonths || '',
                      sno: item?.sipDetails?.length || 0,
                    })
                : item?.sipDetails,
              lumpsumDetails: checkLumpsum([application?.modeOfInvestment || ''])
                ? {
                    ...item?.lumpsumDetails,
                    percentage: checkLumpsum([application?.modeOfInvestment || ''])
                      ? (item.lumpsumDetails?.percentage || '')
                          ?.split(',')
                          ?.includes(application.investmentPercentage || '')
                        ? item.lumpsumDetails?.percentage || ''
                        : (item.lumpsumDetails?.percentage || '')
                            ?.split(',')
                            .concat(application.investmentPercentage?.toString() || '')
                            .filter((item) => item)
                            .toString()
                      : item.lumpsumDetails?.percentage || '',
                  }
                : item?.lumpsumDetails,
            };
          } else return item;
        }) as FundProps[];
        setFundsList(updatedFundPlan);
        const updatePlans =
          application?.schemeId &&
          application?.scheme.isActive &&
          application?.planId &&
          !application.plan?.isActive
            ? ({
                ...updatedFundPlan.find((fund) => Number(fund.id) === Number(scheme?.id)),
                plans: [
                  ...(
                    updatedFundPlan.find(
                      (fund) => Number(fund.id) === Number(scheme?.id)
                    ) as unknown as FundProps
                  ).plans,
                  application.plan,
                ],
              } as unknown as FundProps)
            : updatedFundPlan.find((fund) => Number(fund.id) === Number(scheme?.id)) || null;
        setSelectedFund(updatePlans);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentAlive = false;
    };
  }, [application]);

  const getClassPlanOptionsOrDetails = (isAccreditedInvestor: boolean, detail?: string) => {
    if (detail) {
      return selectedFund?.[detail] || '';
    }
    const plansCombinedWithApplicationPlan = selectedFund?.plans?.some(
      (plan) => Number(plan?.id) === Number(application?.planId)
    )
      ? selectedFund?.plans
      : application?.schemeId?.toString() === selectedFund?.id?.toString()
      ? selectedFund?.plans?.concat(application?.plan as unknown as ClassPlanProps)
      : selectedFund?.plans;
    const filteredPlans = (
      isAccreditedInvestor
        ? plansCombinedWithApplicationPlan?.filter((plan) =>
            isAccreditedInvestorApplicable(plan?.accreditedInvestorApplicable)
          )
        : plansCombinedWithApplicationPlan
    )?.filter((ele) => ele);
    return (
      filteredPlans?.map((plan) => ({
        key: plan?.planDescription,
        value: Number(plan?.id),
      })) || []
    );
  };

  const percentageMaster = (investmentCategory: string) => {
    if (checkDrawdown([investmentCategory])) {
      return selectedFund?.drawdownDetails?.percentage?.split(',');
    }
    if (checkSip([investmentCategory])) {
      return selectedFund?.sipDetails?.map((item) => item?.percentage);
    }
    if (checkLumpsum([investmentCategory])) {
      return selectedFund?.lumpsumDetails?.percentage?.split(',');
    }
    return [];
  };

  const monthsMaster = (investmentCategory: string, percentage?: string) => {
    if (checkDrawdown([investmentCategory])) {
      return selectedFund?.drawdownDetails?.months?.split(',');
    }
    if (checkSip([investmentCategory])) {
      return selectedFund?.sipDetails
        ?.find((item) => item.percentage === percentage)
        ?.months?.split(',');
    }
    if (checkLumpsum([investmentCategory])) {
      return selectedFund?.lumpsumDetails?.months?.split(',');
    }
    return [];
  };

  useEffect(() => {
    (async function () {
      try {
        const jointHodersMdmsMasters = (await dispatch(
          jointHolderRelationsList()
        )) as unknown as JointholderRelationMaster;
        setJointHoldersData(jointHodersMdmsMasters);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  const isFieldDisabled = [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role);

  return (
    <>
      <Formik
        initialValues={paymentDetails}
        onSubmit={handleSubmit}
        enableReinitialize={true}
        validate={(values: Values) => {
          const minCommitmentAmountBasedOnJointHolders =
            application && application.applicants?.length > 1 && jointHoldersData
              ? (updatedCommitmentAmount(
                  Number(minCommitmentAmount),
                  application.applicants,
                  jointHoldersData
                ) as number)
              : minCommitmentAmount;
          try {
            validateYupSchema(
              values,
              investmentPaymentDetailsSchema(
                //minCommitmentAmountBasedOnJointHolders,
                (values?.groupInvestment
                  ? selectedPlan?.minInvestmentAmt
                  : values?.isAccreditedInvestor
                  ? selectedPlan?.accreditedMinCommitmentAmount || 0
                  : minCommitmentAmountBasedOnJointHolders) as number,
                maxCommitmentAmount,
                Number(values.investmentPercentage),
                selectedPlan?.currency || '',
                selectedFund?.modeOfInvestment || [],
                percentageMaster(values?.modeOfInvestment || '') || [],
                monthsMaster(values?.modeOfInvestment || '', values?.investmentPercentage || '') ||
                  [],
                application?.createdAt || '',
                selectedFund?.schemeCode || '',
                maxHurdleRate === 0 || maxHurdleRate ? Number(maxHurdleRate) : 100,
                maxPerformanceFee === 0 || maxPerformanceFee ? Number(maxPerformanceFee) : 100,
                minHurdleRate,
                minPerformanceFee,
                minAddReturnSplit,
                maxAddReturnSplit
              ),
              true,
              values
            );
          } catch (e) {
            return yupToFormErrors(e);
          }
        }}>
        {({ handleSubmit, values, setValues }) => (
          <Grid
            container
            rowSpacing={1}
            columnSpacing={5}
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{
              width: '100%',
              ml: 0,
              '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            }}>
            <Grid item xs={12}>
              <MFCheckbox
                name={`isAccreditedInvestor`}
                label="Accredited Investor"
                sx={{ mt: 1 }}
                onChange={({ target: { checked } }) => {
                  setValues({
                    ...values,
                    ...fundInitialValues,
                    isAccreditedInvestor: checked,
                    groupInvestment: values.groupInvestment,
                    groupName: values.groupName,
                  });
                  setSelectedFund(null);
                  setSelectedPlan(null);
                }}
                checked={values?.isAccreditedInvestor || false}
                disabled={isFieldDisabled}
              />
            </Grid>
            {/* Group Investment checkbox and Group Name hidden - driven by Family Group Folio selection in contributor details */}
            {/* <Grid item xs={12}>
              <MFCheckbox
                name={`groupInvestment`}
                label="Group Investment"
                sx={{ mt: 1 }}
                onChange={({ target: { checked } }) => {
                  setValues({
                    ...fundInitialValues,
                    ...values,
                    groupInvestment: checked,
                  });
                }}
                disabled={isFieldDisabled}
              />
            </Grid>
            {values.groupInvestment && (
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={'groupName'}
                  label="Group Name "
                  placeholder="Enter Group Name"
                />
              </Grid>
            )} */}
            <Grid item xs={12}>
              <SearchableSelect
                name={'schemeId'}
                label="Fund (Scheme) *"
                items={fundsList?.map((fund) => ({
                  value: Number(fund?.id),
                  key: fund?.schemeName,
                }))}
                onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
                  setValues({
                    ...values,
                    ...fundInitialValues,
                    schemeId: value as string,
                    setupFeeAmount: 0,
                    setupFeeGST: 0,
                    totalSetupFee: 0,
                    setupFeeTDS: 0,
                    netSetupFeeLessTDS: 0,
                    totalAmountPayable: 0,
                    distributorFee: 0,
                    isAccreditedInvestor: values.isAccreditedInvestor,
                    groupInvestment: values.groupInvestment,
                    groupName: values.groupName || '',
                    isOnlyXalt:
                      fundsList.find((f) => Number(f.id) === Number(value))?.isOnlyXalt || false,
                    // distributorFeeType: '',
                  });
                  setSelectedFund(fundsList.find((f) => Number(f.id) === value) || null);
                  setSelectedPlan(null);
                }}
                disabled={isFieldDisabled}
                searchFieldPlaceholder={'Search Fund (Scheme)'}
              />
            </Grid>
            {/* {!!values.schemeId && (
            <Grid item xs={12}>
              <Box
                sx={{
                  boxShadow: '0px 0px 12px 2px rgba(0, 0, 0, 0.1)',
                  borderRadius: '10px',
                  p: { xs: '20px', sm: '30px 40px' },
                  my: 2,
                }}>
                <Box
                  onClick={() => setOpen(!open)}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins, sans-serif',
                      fontWeight: 600,
                      fontSize: 16,
                      color: 'primary.main',
                      letterSpacing: '0.05em',
                    }}>
                    Bank Details related to this fund (Scheme)
                  </Typography>
                  <ExpandMoreIcon sx={{ transform: open ? 'rotate(180deg)' : '' }} />
                </Box>
                {open && (
                  <Grid
                    container
                    spacing={3}
                    sx={{
                      mt: 3,
                      '.MuiTypography-root': {
                        fontSize: 16,
                        letterSpacing: '0.05em',
                        '&.MuiTypography-body2 ': { fontWeight: 600 },
                      },
                    }}>
                    <Grid item xs={12} sm={6}>
                      <Typography gutterBottom>Bank Name</Typography>
                      <Typography variant="body2">
                        {getClassPlanOptionsOrDetails('bankName')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography gutterBottom>Bank Account Number</Typography>
                      <Typography variant="body2">
                        {getClassPlanOptionsOrDetails('bankAccountNumber')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography gutterBottom>IFSC Code</Typography>
                      <Typography variant="body2">
                        {getClassPlanOptionsOrDetails('ifscCode')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography gutterBottom>Bank Branch</Typography>
                      <Typography variant="body2">
                        {getClassPlanOptionsOrDetails('bankBranch')}
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </Box>
            </Grid>
          )} */}
            <Grid item xs={12} sm={6}>
              <MFSelectField
                name={'modeOfInvestment'}
                label="Mode Of Investment *"
                items={(selectedFund?.modeOfInvestment || []).map((item) => ({
                  key: INVESTMENT_METHOD_MASTER[item],
                  value: item,
                }))}
                onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
                  const percentageVal = percentageMaster(value as string) || [];
                  const investmentPercentage =
                    value && percentageVal?.length === 1 ? percentageVal[0] : '';
                  const monthsVal = monthsMaster(value as string, investmentPercentage) || [];
                  setValues({
                    ...values,
                    modeOfInvestment: value as string,
                    investmentPercentage,
                    investmentMonths:
                      value && checkSip([value as string]) && monthsVal?.length === 1
                        ? monthsVal[0]
                        : '',
                    commitmentAmount: 0,
                  });
                }}
                disabled={!values.schemeId || isFieldDisabled}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFSelectField
                name={'investmentPercentage'}
                label="Investment Percentage *"
                items={(percentageMaster(values?.modeOfInvestment || '') || [])
                  ?.sort((a, b) => Number(a) - Number(b))
                  .map((item) => ({
                    key: item,
                    value: item,
                  }))}
                onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
                  setValues({
                    ...values,
                    investmentPercentage: value as string,
                    contributionChequeAmount: values.commitmentAmount
                      ? (Number(values.commitmentAmount) * Number(value)) / 100
                      : values.contributionChequeAmount,
                    totalAmountPayable: Number(
                      (Number(values.commitmentAmount) * Number(value)) / 100
                    )
                      ? Number((Number(values.commitmentAmount) * Number(value)) / 100)
                      : Number(values.commitmentAmount),
                  });
                }}
                disabled={!values.schemeId || !values.modeOfInvestment || isFieldDisabled}
              />
            </Grid>
            {values.modeOfInvestment && checkSip([values.modeOfInvestment]) && (
              <Grid item xs={12} sm={6}>
                <MFSelectField
                  name={'investmentMonths'}
                  label="Investment Months *"
                  items={(
                    monthsMaster(
                      values?.modeOfInvestment || '',
                      values?.investmentPercentage || ''
                    ) || []
                  )
                    ?.sort((a, b) => Number(a) - Number(b))
                    .map((item) => ({
                      key: item,
                      value: item,
                    }))}
                  disabled={!values.schemeId || !values.modeOfInvestment || isFieldDisabled}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={6}>
              <SearchableSelect
                name={'planId'}
                label="Class (Plan) *"
                items={
                  getClassPlanOptionsOrDetails(values?.isAccreditedInvestor as boolean) as [
                    { key: string; value: string | number }
                  ]
                }
                disabled={!values.schemeId || !values.modeOfInvestment || isFieldDisabled}
                onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
                  const selectedPlan = selectedFund?.plans
                    ?.filter((plan) => plan.isActive)
                    ?.find((p) => Number(p.id) === value);
                  setSelectedPlan(selectedPlan || null);
                  setValues({
                    ...values,
                    planId: value as string,
                    commitmentAmount: 0,
                    contributionChequeAmount: 0,
                    setupFeePercentage: selectedPlan?.setupFee,
                    managementFeesRate: selectedPlan?.managementFee,
                    setupFeeAmount: 0,
                    setupFeeGST: 0,
                    totalSetupFee: 0,
                    setupFeeTDS: 0,
                    netSetupFeeLessTDS: 0,
                    totalAmountPayable: 0,
                    hurdleRateApplicable: selectedPlan?.hurdleRateApplicable,
                    hurdleRateType: selectedPlan?.hurdleRateType,
                    hurdleRate: selectedPlan?.defaultHurdleRate || 0,
                    performanceFeeApplicable: selectedPlan?.performanceFeeApplicable,
                    performanceFeeType: selectedPlan?.performanceFeeType,
                    performanceFee: selectedPlan?.defaultPerformanceFee || 0,
                    transactionCurrency: selectedPlan?.transactionCurrency,
                    addReturnSplit: Number(selectedPlan?.defaultAddReturnSplit) || 0,
                    addReturnSplitType: selectedPlan?.addReturnSplitType,
                    addReturnSplitApplicable: selectedPlan?.addReturnSplitApplicable,
                  });
                }}
                searchFieldPlaceholder={'Search Class (Plan)'}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ '.MuiFormControl-root': { marginBottom: '2px' } }}>
              <MFTextField
                name={'commitmentAmount'}
                label="Commitment Amount *"
                type="number"
                placeholder="Enter Commitment Amount"
                onKeyDown={(e) => {
                  allowOnlyNumbers(e);
                }}
                onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
                  const feeAmountObj = setUpFeeCalculations(
                    Number(value) || 0,
                    values.setupFeePercentage || 0
                  );
                  const netSetupFee = feeAmountObj.totalSetupFee - (values.setupFeeTDS || 0);
                  setValues({
                    ...values,
                    commitmentAmount: value ? Number(value) : null,
                    contributionChequeAmount: values.investmentPercentage
                      ? (Number(value) * Number(values.investmentPercentage)) / 100
                      : values.contributionChequeAmount,
                    setupFeeAmount: feeAmountObj.feeAmount,
                    setupFeeGST: feeAmountObj.feeGst,
                    totalSetupFee: feeAmountObj.totalSetupFee,
                    netSetupFeeLessTDS: netSetupFee,
                    totalAmountPayable: Number(
                      (Number(value) * Number(values.investmentPercentage)) / 100
                    )
                      ? Number((Number(value) * Number(values.investmentPercentage)) / 100)
                      : Number(value),
                  });
                }}
                trimOnBlur={false}
                disabled={isFieldDisabled || !values.planId}
              />
              {values.commitmentAmount != 0 && (
                <Typography sx={{ fontSize: 13 }}>
                  {currencyConversion(values.commitmentAmount, selectedPlan?.currency)}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={'managementFeesRate'}
                label="Management Fees Rate"
                placeholder="Enter Management Fee Percentage"
                type="number"
                onKeyDown={(e) => {
                  allowOnlyNumbers(e);
                }}
                trimOnBlur={false}
                disabled={true}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6}>
            <MFTextField
              name={'taxRate'}
              label="Tax Rate"
              placeholder="Enter Tax Rate"
              type="number"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFSelectField
              name={'drawDownNumber'}
              label="Drawdown Number"
              items={DrawDownMasters.map((master) => ({ key: master, value: master }))}
            />
          </Grid> */}
            <Grid item xs={12} sm={6} sx={{ '.MuiFormControl-root': { marginBottom: '2px' } }}>
              <MFTextField
                name={'contributionChequeAmount'}
                label="Initial Contribution Amount *"
                placeholder="Enter Initial Contribution Amount"
                type="number"
                onKeyDown={(e) => {
                  allowOnlyNumbers(e);
                }}
                onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
                  const feeAmountObj = setUpFeeCalculations(
                    values.commitmentAmount || 0,
                    values.setupFeePercentage || 0
                  );
                  const netSetupFee = feeAmountObj.totalSetupFee - (values.setupFeeTDS || 0);
                  setValues({
                    ...values,
                    contributionChequeAmount: value ? Number(value) : null,
                    setupFeeAmount: feeAmountObj.feeAmount,
                    setupFeeGST: feeAmountObj.feeGst,
                    totalSetupFee: feeAmountObj.totalSetupFee,
                    netSetupFeeLessTDS: netSetupFee,
                    totalAmountPayable: Number(value) || values.commitmentAmount,
                  });
                }}
                trimOnBlur={false}
                disabled={true}
              />
              {values.contributionChequeAmount != 0 && (
                <Typography sx={{ fontSize: 13 }}>
                  {currencyConversion(values.contributionChequeAmount, selectedPlan?.currency)}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={'setupFeePercentage'}
                label="Setup Fee Percentage *"
                type="number"
                placeholder="Enter Setup Fee Percentage"
                onKeyDown={(e) => {
                  allowOnlyNumbers(e);
                }}
                onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
                  const feeAmountObj = setUpFeeCalculations(
                    values.commitmentAmount || 0,
                    Number(value)
                  );
                  const netSetupFee = feeAmountObj.totalSetupFee - (values.setupFeeTDS || 0);
                  setValues({
                    ...values,
                    setupFeePercentage: value ? Number(value) : null,
                    setupFeeAmount: feeAmountObj.feeAmount,
                    setupFeeGST: feeAmountObj.feeGst,
                    totalSetupFee: feeAmountObj.totalSetupFee,
                    netSetupFeeLessTDS: netSetupFee,
                    totalAmountPayable: values.contributionChequeAmount || values.commitmentAmount,
                  });
                }}
                trimOnBlur={false}
                disabled={isFieldDisabled || !values.planId}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ '.MuiFormControl-root': { marginBottom: '2px' } }}>
              <MFTextField
                name={'setupFeeAmount'}
                label="Setup Fee Amount"
                type="number"
                placeholder="Enter Setup Fee Amount"
                onKeyDown={(e) => {
                  allowOnlyNumbers(e);
                }}
                trimOnBlur={false}
                disabled={true}
              />
              {values.setupFeeAmount != 0 && (
                <Typography sx={{ fontSize: 13 }}>
                  {currencyConversion(values.setupFeeAmount, selectedPlan?.currency)}
                </Typography>
              )}
            </Grid>
            {isFieldApplicable(values?.hurdleRateApplicable || '') && (
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={'hurdleRate'}
                  label={`Hurdle Rate % *`}
                  placeholder="Enter Hurdle Rate"
                  type="number"
                  onKeyDown={(e) => {
                    allowOnlyNumbers(e);
                  }}
                  trimOnBlur={false}
                  disabled={
                    !isFieldVariable(
                      values?.hurdleRateType || '',
                      values?.hurdleRateApplicable || ''
                    ) ||
                    isFieldDisabled ||
                    !values.planId
                  }
                />
              </Grid>
            )}
            {isFieldApplicable(values?.performanceFeeApplicable || '') && (
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={'performanceFee'}
                  label={`Performance Fee % *`}
                  placeholder="Enter Performance Fee"
                  type="number"
                  onKeyDown={(e) => {
                    allowOnlyNumbers(e);
                  }}
                  trimOnBlur={false}
                  disabled={
                    !isFieldVariable(
                      values?.performanceFeeType || '',
                      values?.performanceFeeApplicable || ''
                    ) ||
                    isFieldDisabled ||
                    !values.planId
                  }
                />
              </Grid>
            )}
            {isFieldApplicable(values?.addReturnSplitApplicable || '') && (
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={'addReturnSplit'}
                  label={`Additional Return Split % *`}
                  placeholder="Enter Additional Return Split"
                  type="number"
                  onKeyDown={(e) => {
                    allowOnlyNumbers(e);
                  }}
                  trimOnBlur={false}
                  disabled={true}
                />
              </Grid>
            )}
            {/* <Grid item xs={12} sm={6} sx={{ '.MuiFormControl-root': { marginBottom: '2px' } }}>
            <MFTextField
              name={'setupFeeGST'}
              label="GST (GST On Setup Fee Amount)"
              type="number"
              placeholder="Enter GST"
              onKeyDown={(e) => {
                allowOnlyNumbers(e);
              }}
              trimOnBlur={false}
              disabled={true}
            />
            {values.setupFeeGST != 0 && (
              <Typography sx={{ fontSize: 13 }}>
                {currencyConversion(values.setupFeeGST, selectedPlan?.currency)}
              </Typography>
            )}
          </Grid> */}
            {/* <Grid item xs={12} sm={6} sx={{ '.MuiFormControl-root': { marginBottom: '2px' } }}>
            <MFTextField
              name={'totalSetupFee'}
              label="Total Setup Fee"
              type="number"
              placeholder="Enter Total Setup Fee"
              onKeyDown={(e) => {
                allowOnlyNumbers(e);
              }}
              trimOnBlur={false}
              disabled={true}
            />
            {values.totalSetupFee != 0 && (
              <Typography sx={{ fontSize: 13 }}>
                {currencyConversion(values.totalSetupFee, selectedPlan?.currency)}
              </Typography>
            )}
          </Grid> */}
            {/* <Grid item xs={12} sm={6} sx={{ '.MuiFormControl-root': { marginBottom: '2px' } }}>
            <MFTextField
              name={'setupFeeTDS'}
              label="TDS"
              type="number"
              placeholder="Enter TDS"
              onKeyDown={(e) => {
                allowOnlyNumbers(e);
              }}
              onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
                const setupFeeLessTDS = (values.totalSetupFee || 0) - Number(value);
                setValues({
                  ...values,
                  setupFeeTDS: value ? Number(value) : null,
                  netSetupFeeLessTDS:
                    values.totalSetupFee && value ? setupFeeLessTDS : values.totalSetupFee,
                  totalAmountPayable: values.contributionChequeAmount || values.commitmentAmount,
                });
              }}
              trimOnBlur={false}
              disabled={isFieldDisabled || !values.planId}
            />
            {values.setupFeeTDS != 0 && (
              <Typography sx={{ fontSize: 13 }}>
                {currencyConversion(values.setupFeeTDS, selectedPlan?.currency)}
              </Typography>
            )}
          </Grid> */}
            {/* <Grid item xs={12} sm={6} sx={{ '.MuiFormControl-root': { marginBottom: '2px' } }}>
            <MFTextField
              name={'netSetupFeeLessTDS'}
              label="Setup Fee Payable"
              type="number"
              placeholder="Enter Setup Fee Payable"
              onKeyDown={(e) => {
                allowOnlyNumbers(e);
              }}
              trimOnBlur={false}
              disabled={true}
            />
            {values.netSetupFeeLessTDS != 0 && (
              <Typography sx={{ fontSize: 13 }}>
                {currencyConversion(values.netSetupFeeLessTDS, selectedPlan?.currency)}
              </Typography>
            )}
          </Grid> */}
            <Grid item xs={12} sm={6} sx={{ '.MuiFormControl-root': { marginBottom: '2px' } }}>
              <MFTextField
                name={'totalAmountPayable'}
                label="Total Amount Payable"
                type="number"
                placeholder="Enter Total Amount Payable"
                onKeyDown={(e) => {
                  allowOnlyNumbers(e);
                }}
                trimOnBlur={false}
                disabled={true}
              />
              {values.totalAmountPayable != 0 && (
                <Typography sx={{ fontSize: 13 }}>
                  {currencyConversion(values.totalAmountPayable, selectedPlan?.currency)}
                </Typography>
              )}
            </Grid>
            {/* <Grid
            item
            xs={12}
            sm={6}
            sx={{ '.MuiFormControl-root': { marginBottom: '2px', marginTop: '16px' } }}>
            <UseRadioGroup
              formLabel="SIP *"
              name={`sip`}
              items={Object.keys(SIP_MASTER).map((option) => ({
                label: SIP_MASTER[option],
                value: option,
              }))}
            />
          </Grid> */}
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ '.MuiFormControl-root': { marginBottom: '2px', marginTop: '16px' } }}>
              <UseRadioGroup
                formLabel="Mode Of Payment *"
                name={`modeOfPayment`}
                items={Object.keys(MODE_OF_PAYMENT_MASTER).map((option) => ({
                  label: MODE_OF_PAYMENT_MASTER[option],
                  value: option,
                }))}
                disabled={isFieldDisabled}
              />
            </Grid>
            {isNEFT(values.modeOfPayment || '') && (
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={'neftCode'}
                  label="NEFT Code *"
                  placeholder="Enter NEFT Code"
                  disabled={isFieldDisabled}
                />
              </Grid>
            )}
            {isChequeOrRTGS(values.modeOfPayment || '') && (
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={'paymentRefNo'}
                  label="Cheque No/UTR No *"
                  placeholder="Enter Cheque No/UTR No"
                  disabled={isFieldDisabled}
                />
              </Grid>
            )}
            <Grid item xs={12} sm={6}>
              <DatePicker
                label={'Instrument Date'}
                placeholder={'Enter Instrument Date'}
                inputLabelStyles={{
                  transform: 'unset',
                  fontSize: 14,
                  fontWeight: 500,
                  color: 'rgba(0,0,0,0.7)',
                }}
                name="paymentRefDate"
                disabled={isFieldDisabled}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={'placementFee'}
                label="Placement Fee (%) *"
                placeholder="Enter Placement Fee (%)"
                type="number"
                onKeyDown={(e) => {
                  allowOnlyNumbers(e);
                }}
                trimOnBlur={false}
                disabled={isFieldDisabled}
              />
            </Grid>
            {(isSchemeNICO(selectedFund?.schemeCode || '') ||
              isSchemeNIDI2A(selectedFund?.schemeCode || '')) && (
              <>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ '.MuiFormControl-root': { marginBottom: '2px', marginTop: '16px' } }}>
                  <UseRadioGroup
                    formLabel="Distribution Fee Type *"
                    name={`distributorFeeType`}
                    items={Object.keys(DISTRIBUTION_FEE_TYPE_MASTER).map((option) => ({
                      label: DISTRIBUTION_FEE_TYPE_MASTER[option],
                      value: option,
                    }))}
                    disabled={isFieldDisabled}
                  />
                </Grid>
                {DISTRIBUTION_FEE_TYPE_MASTER[values?.distributorFeeType || ''] ===
                  DISTRIBUTION_FEE_TYPE_MASTER.upfront_plus_trail && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={'upfrontPlusTrail'}
                      label={`${
                        DISTRIBUTION_FEE_TYPE_MASTER[values?.distributorFeeType || '']
                      } (%)`}
                      placeholder={`Enter ${
                        DISTRIBUTION_FEE_TYPE_MASTER[values?.distributorFeeType || '']
                      } (%) *`}
                      type="number"
                      onKeyDown={(e) => {
                        allowOnlyNumbers(e);
                      }}
                      trimOnBlur={false}
                      disabled={isFieldDisabled}
                    />
                  </Grid>
                )}
              </>
            )}
            {DISTRIBUTION_FEE_TYPE_MASTER[values.distributorFeeType || ''] !=
              DISTRIBUTION_FEE_TYPE_MASTER.upfront_plus_trail && (
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={'distributorFee'}
                  label={`${
                    isSchemeNICO(selectedFund?.schemeCode || '') ||
                    isSchemeNIDI2A(selectedFund?.schemeCode || '')
                      ? DISTRIBUTION_FEE_TYPE_MASTER[values?.distributorFeeType || '']
                      : 'Distribution Fee'
                  } (%)`}
                  placeholder={`Enter ${
                    isSchemeNICO(selectedFund?.schemeCode || '') ||
                    isSchemeNIDI2A(selectedFund?.schemeCode || '')
                      ? DISTRIBUTION_FEE_TYPE_MASTER[values?.distributorFeeType || '']
                      : 'Distribution Fee'
                  } (%)`}
                  type="number"
                  onKeyDown={(e) => {
                    allowOnlyNumbers(e);
                  }}
                  trimOnBlur={false}
                  disabled={isFieldDisabled}
                />
              </Grid>
            )}

            <SubHeading
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}>
              Drawn on Bank Details
            </SubHeading>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`drawnOnBank`}
                label="Drawn On Bank *"
                placeholder="Enter Drawn On Bank"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`drawnAccountNumber`}
                label="Account Number *"
                placeholder="Enter Account Number"
                info={`Document is needed if the investor's bank account and drawn on bank accounts are not same`}
                infoprops={{ left: 130 }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField
                name={`drawnBankBranch`}
                label="Bank Branch *"
                placeholder="Enter Bank Branch"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MFTextField name={`drawnCity`} label="City *" placeholder="Enter City" />
            </Grid>
            {/* <Grid
            item
            xs={12}
            onClick={() => setPaymentOpen(!paymentOpen)}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'pointer',
              my: 2,
            }}>
            <Typography
              component="h3"
              sx={{
                fontFamily: 'Poppins, sans-serif',
                fontSize: 25,
                fontWeight: 500,
                color: 'secondary.main',
              }}>
              Payment Details
            </Typography>
            <ExpandMoreIcon sx={{ fontSize: 30, transform: paymentOpen ? 'rotate(180deg)' : '' }} />
          </Grid> */}
            {/* {paymentOpen && (
            <>
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={'paymentBankame'}
                  label="Payment Bank Name"
                  placeholder="Enter Payment Bank Name"
                  disabled={isFieldDisabled}
                />
              </Grid>
              <Grid item xs={12} sm={6} />
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={'paymentBankAccountNumber'}
                  label="Payment Bank Account Number"
                  placeholder="Enter Payment Bank Account Number"
                  disabled={isFieldDisabled}
                />
              </Grid>
              <Grid item xs={12} sm={6} sx={{ pt: '25px !important' }}>
                <UseRadioGroup
                  name={'paymentBankAccontType'}
                  formLabel="Payment Bank Account Type"
                  defaultValue="current"
                  items={[
                    { label: 'Current', value: 'current' },
                    { label: 'Savings', value: 'savings' },
                  ]}
                  disabled={isFieldDisabled}
                />
              </Grid>
              <Grid item xs={12}>
                <UseRadioGroup
                  name={'modeOfPayment'}
                  formLabel="Mode of Payment"
                  defaultValue="cheque"
                  items={[
                    { label: 'Cheque', value: 'cheque' },
                    { label: 'RTGS', value: 'rtgs' },
                    { label: 'Online Transfer', value: 'online-transfer' },
                    { label: 'Others', value: 'others' },
                  ]}
                  disabled={isFieldDisabled}
                />
              </Grid>
              {values.modeOfPayment === 'cheque' && (
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    label={'Payment/Cheque Date'}
                    placeholder={'Enter Cheque Date'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    name="chequeDate"
                    disabled={isFieldDisabled}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6}>
                <MFTextField
                  name={'paymentRefNo'}
                  label="Payment Ref No"
                  placeholder="Enter Payment Ref No"
                  disabled={isFieldDisabled}
                />
              </Grid>
            </>
          )} */}
            <ProceedSaveLater
              saveLater={() => {
                setValues({
                  ...values,
                  saveType: 'save for later',
                });
              }}
              saveAndProceed={() => {
                setValues({
                  ...values,
                  saveType: 'save and proceed',
                });
              }}
              loader={loading}
              clickedButton={values.saveType}
            />
          </Grid>
        )}
      </Formik>
      <ConfirmationDialog
        message={`Are you sure you want to proceed with Group Investment Option ?`}
        open={openDialog?.investmentData.groupInvestment as boolean}
        setOpen={() => setDialog(null)}
        onSave={async () => {
          setDialog(null);
          try {
            setLoading(true);
            await submitInvestmentData(
              openDialog?.investmentData as Values,
              openDialog?.checkApplication as boolean
            );
          } catch (e) {
            setLoading(false);
            console.error((e as Error).message);
          }
        }}
        onCancel={() => setDialog(null)}
        displayInfo={
          Number(openDialog?.investmentData.commitmentAmount) > Number(maxCommitmentAmount)
            ? 'Commitment amount does not match with provided class of units'
            : ''
        }
      />
    </>
  );
}
